import { getPlatformBridge } from '@/logic/bridges';
import { isAndroidWrapper, isIosWrapper, isXsell } from '@/logic/platform';

export const shouldUseWebRealityCheck = (): boolean => {
    if (isXsell()) return false;
    if (isAndroidWrapper()) {
        const nativeEnabled = getPlatformBridge().exec('isNativeRealityCheckEnabled');
        if (nativeEnabled === true) return false;
    }
    if (isIosWrapper()) return false;
    return true;
};
